import { render, staticRenderFns } from "./CustomerBioPanel.vue?vue&type=template&id=268500a4&"
import script from "./CustomerBioPanel.vue?vue&type=script&lang=js&"
export * from "./CustomerBioPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports